import React from 'react'
import { ThreeBounce } from 'better-react-spinkit'
import './AddressLeadForm.css'


export const LeadFormSubmitButton = ({busy, submitting}) => {
  return(
    <div className="form-group col-md">
    <button
      className="btn btn-block btn-primary AddressLeadForm__button"
      disabled={busy || submitting}
      type="submit"
    >
      {(busy || submitting) ? <ThreeBounce color='#fff' size={12} /> : 'Get Started'}
    </button>
  </div>
)}

export default LeadFormSubmitButton


// WEBPACK FOOTER //
// ./src/components/HomeScene/AddressLeadForm/LeadFormSubmitButton.js